<template>
  <el-card shadow="never" style="overflow: visible">
    <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="85px">
      <el-row :gutter="15">
        <el-col :sm="8">
          <div class="smsout">
            <el-tree
              ref="teacherTree"
              :data="teacherList"
              :props="{ label: 'name' }"
              node-key="id"
              :show-checkbox="true"
              :default-expanded-keys="teacherListNode"
            />
          </div>
        </el-col>
        <el-col :sm="10">
          <div class="ele-table-tool">
            <div class="ele-table-tool-title">给教师发送短信</div>
          </div>
          <el-form-item label="短信内容:" prop="detail">
            <el-input type="textarea" :rows="8" v-model="editForm.detail" maxlength="130" show-word-limit />
          </el-form-item>
          <el-form-item label="定时发送：">
            <el-switch v-model="isSendTime" />
          </el-form-item>
          <el-form-item v-show="isSendTime" label="选择日期：">
            <el-date-picker v-model="sendDate" type="datetime" placeholder="选择日期时间" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveDetail()">发 送</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
  // import Treeselect from '@riophae/vue-treeselect'  // 下拉树
  // import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { sendMessageByTeacher, getAllDepartTeachers } from '@/config/api';

  export default {
    name: 'FromDept',
    // components: {Treeselect},
    data() {
      return {
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          detail: [{ required: true, message: '请输入短信内容', trigger: 'blur' }],
        },
        teacherList: [], //部门下老师列表
        teacherListNode: [], //默认展开的数组
        teacherIds: [],
        sendDate: '',
        isSendTime: false,
      };
    },
    mounted() {
      this.queryDept();
    },
    methods: {
      /* 查询部门下老师列表 */
      queryDept() {
        getAllDepartTeachers().then((res) => {
          if (res.data.resCode == 200) {
            this.teacherList = this.$util.toTreeData(res.data.data, 'id', 'parentId');
            this.deleteChildren(this.teacherList);
            this.getRoleTreeRootNode(this.teacherList[0].id);
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 获取树形结构默认展开节点
      getRoleTreeRootNode(provincialCenterId) {
        this.teacherListNode.push(provincialCenterId);
      },
      // 发送短信
      saveDetail() {
        let teacherIds = this.$refs.teacherTree.getCheckedNodes();
        this.getNodeteacherIds(teacherIds);
        this.teacherIds = [...new Set(this.teacherIds)]; //js去重
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            if (this.isSendTime) {
              if (this.sendDate != '') {
                this.editForm.time = this.$util.toDateString(this.sendDate, 'yyyy-MM-dd HH:mm');
              } else {
                this.$message.error('请选择发送日期');
                return false;
              }
            }
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            formData.append('teacherIds', this.teacherIds);
            sendMessageByTeacher(formData).then((res) => {
              this.teacherIds = [];
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs['editForm'].resetFields();
                this.sendDate = '';
                this.isSendTime = false;
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            this.teacherIds = [];
            return false;
          }
        });
      },
      // 循环数组 children为空时删除 且部系年级下无children时禁用
      deleteChildren(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children) {
            if (data[i].children.length) {
              this.deleteChildren(data[i].children);
            } else {
              data[i].disabled = true;
              if (data[i].type !== 2) {
                delete data[i].children;
              }
            }
          }
        }
        return data;
      },

      //循环数组获取教师id
      getNodeteacherIds(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].type == 2) {
            this.teacherIds.push(data[i].id);
          }
        }
      },
    },
  };
</script>

<style scoped>
  .smsout {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 262px);
    box-sizing: border-box;
    overflow-x: auto;
  }
</style>
